(function ($, document, window) {
	'use strict';

	$(function () {
		$('.js-testimonial-collection').each(function () {
			const carousel = $(this);
			const sliderEl = $('.swiper', carousel)[0];
			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				spaceBetween: 20,
				slidesPerView: 1,

				breakpoints: {
					744: {
						spaceBetween: 30,
						slidesPerView: 2,
					},
					1280: {
						spaceBetween: 40,
						slidesPerView: 3,
					},
				},

				navigation: {
					nextEl: $('.js-carousel-nav-next', carousel)[0],
					prevEl: $('.js-carousel-nav-prev', carousel)[0],
				},
			});
		})
	});
})(jQuery, document, window);
